import {FlowNodeData, FlowNodeTypes, SettingParamTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const globalNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.GLOBAL,
  position: {x: 0, y: 0},
  measured: {height: 115, width: 340},
  data: {
    type: FlowNodeTypes.GLOBAL,
    settingsTitle: "Global Settings",
    nodeTitle: "Global Stage",
    onChange: () => {
      console.log("Global node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "Personality & Background",
        icon: "UserCog",
        description:
          "Things good to know for the Assistant, but not related to any specific stage in the conversation",
        params: [
          {
            label: "Instructions",
            placeholder:
              "You are Virtual AI Assistant, you are a fun AI that helps customers with with questions and appointments.",
            type: SettingParamTypes.PROMPT,
            key: "global_instructions",
            value: "",
            required: true,
            requiredLabel:
              "Provide Background Information for the flow to work properly.",
          },
        ],
      },
      // {
      //   title: "Global Actions",
      //   icon: "Zap",
      //   description: "Add actions that could be used anywhere in the flow.",
      //   params: [
      //     {
      //       type: SettingParamTypes.ACTIONS,
      //       key: "global_actions",
      //       value: [],
      //     },
      //   ],
      // },
      // {
      //   title: "FAQ",
      //   icon: "CircleHelp",
      //   description:
      //     "Add common Q&A here for quick AI responses during calls. For complex branching, build it directly in the editor.",
      //   params: [
      //     {
      //       type: SettingParamTypes.MODAL,
      //       key: "faq",
      //       unitName: "FAQ",
      //       value: [],
      //       settingName: "FAQ",
      //       modalSettings: [
      //         {
      //           label: "Question",
      //           value: "",
      //           placeholder: "What is the name of your restaurant?",
      //           key: "title",
      //           type: SettingParamTypes.INPUT,
      //         },
      //         {
      //           label: "Answer",
      //           value: "",
      //           placeholder: "The name of my restaurant is...",
      //           key: "description",
      //           type: SettingParamTypes.TEXTAREA,
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        title: "Objections & Special Cases",
        icon: "OctagonAlert",
        description:
          "Set up responses for your AI Voice Assistant to handle common situations or user objections.",
        params: [
          {
            type: SettingParamTypes.MODAL,
            key: "special_cases",
            unitName: "Case",
            value: [],
            settingName: "Special Cases",
            modalDescription:
              "Add instructions on how the Assistant should handle special cases.",
            modalSettings: [
              {
                label: "Case",
                value: "",
                placeholder: "The user asks if your are an AI",
                key: "title",
                type: SettingParamTypes.INPUT,
              },
              {
                label: "Instructions",
                value: "",
                placeholder: "Confirm and point out the advantages...",
                key: "description",
                type: SettingParamTypes.TEXTAREA,
              },
            ],
          },
        ],
      },
    ],
  },
};
